export enum FindGamesRoutes {
  ROOT = '',
  MAP = 'map',
  LOCATION = 'location'
}
